// =========================
// src/components/Navigation/Navigation.jsx
// =========================
import React from "react";
import "./navigation.css";

import heroImg from "../Assets/img-header-baterias-agora.png";
import boltIcon from "../Assets/icone_energia_bateria.png";
import iconCaminhao from "../Assets/icone_caminhao.png";
import logoBa from "../Assets/logo-novo-baterias-agora.png";

import imgHeliar from "../Assets/carro-heliar.png";
import imgMoura from "../Assets/moto-moura.png";
import imgCaminhaoJupiter from "../Assets/caminhao-jupiter.png";
import imgLumix from "../Assets/carro-lumix.png";
import imgMouraCaminhao from "../Assets/caminhao-moura.png";
import imgZettaCarro from "../Assets/carro-zetta.png";
import imgMarteMoto from "../Assets/moto-marte.png";
import imgMouraMoto from "../Assets/moto-moura.png";
import iconWhats from "../Assets/icone_whats.png";
import imgBateriaMoura from "../Assets/bateria-moura-sem-fundo.png";

/* ===== util distância (haversine) ===== */
function toRad(v) {
  return (v * Math.PI) / 180;
}
function distanceKm(a, b) {
  const R = 6371;
  const dLat = toRad(b.lat - a.lat);
  const dLon = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const x =
    Math.sin(dLat / 2) ** 2 +
    Math.sin(dLon / 2) ** 2 * Math.cos(lat1) * Math.cos(lat2);
  return 2 * R * Math.asin(Math.sqrt(x));
}

/* ===== origem (base da loja) ===== */
const ORIGEM = { lat: -23.55052, lng: -46.633308 };

/* <<< ATUALIZE O NÚMERO AQUI >>> */
const WHATS_NUMBER_E164 = "5516982172448";

/* <<< mensagem padronizada >>> */
const WHATS_MESSAGE =
  "Olá! Vi pelo site Baterias Agora e desejo fazer um pedido.";
const whatsLinkHero = `https://api.whatsapp.com/send?phone=${WHATS_NUMBER_E164}&text=${encodeURIComponent(
  WHATS_MESSAGE
)}`;

/* ===== ETA por regra ===== */
function etaByDistanceKM(km) {
  return km >= 10
    ? "em 30 minutos estaremos chegando."
    : "em 40 minutos estaremos chegando.";
}

/* ===== fallback de coords ===== */
function fmtCoords(lat, lng) {
  return `${lat.toFixed(5)}, ${lng.toFixed(5)}`;
}

/* ===== normaliza o endereço do Nominatim ===== */
function normalizeAddress(addr) {
  if (!addr) return null;

  const viaRaw =
    addr.road ||
    addr.pedestrian ||
    addr.residential ||
    addr.footway ||
    addr.cycleway ||
    addr.path ||
    addr.highway ||
    "";
  const via = (viaRaw || "").replace(/\s+/g, " ").trim();
  const viaLower = via.toLowerCase();

  // se a via já começa com o tipo (rua/avenida/etc), não adiciona outro
  const alreadyHasType =
    /^(rua|r\.|avenida|av\.?|alameda|travessa|rodovia|estrada|praça|praca)\b/i.test(
      viaLower
    );

  let tipo = "";
  if (!alreadyHasType) {
    if (/^(av|avenida)\b/.test(viaLower) || viaLower.includes("avenida")) {
      tipo = "Avenida";
    } else {
      tipo = "Rua";
    }
  }

  const numero = addr.house_number || "";
  const cidade =
    addr.city || addr.town || addr.village || addr.municipality || "";
  const bairro = addr.suburb || addr.neighbourhood || "";
  const uf =
    addr.state_code ||
    (addr.state && addr.state.match(/\b[A-Z]{2}\b/)?.[0]) ||
    "";
  const cep = addr.postcode || "";

  const ruaNumero = [tipo, via, numero]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
  const cidadeUF = [cidade, uf].filter(Boolean).join(" - ");
  const formatted = [ruaNumero, bairro, cidadeUF].filter(Boolean).join(", ");

  return {
    via,
    tipo,
    numero,
    cidade,
    bairro,
    uf,
    cep,
    ruaNumero,
    cidadeUF,
    formatted,
  };
}

/* ===== monta mensagem padrão do Whats ===== */
function buildWhatsMsg(base, loc) {
  if (!loc) return base;
  const enderecoShow =
    loc.endereco && loc.endereco.length > 3
      ? `${loc.endereco}${loc.cep ? ` – CEP ${loc.cep}` : ""}`
      : fmtCoords(loc.lat, loc.lng);
  const trecho =
    `\n\nLocalização: ${enderecoShow}` +
    (loc.eta ? `\nPrevisão de chegada: ${loc.eta}` : "");
  return base + encodeURIComponent(trecho);
}

// Somente localização (SEM ETA) para o botão "Solicitar"
function buildWhatsMsgNoEta(base, loc) {
  if (!loc) return base;
  const enderecoShow =
    loc.endereco && loc.endereco.length > 3
      ? `${loc.endereco}${loc.cep ? ` – CEP ${loc.cep}` : ""}`
      : fmtCoords(loc.lat, loc.lng);
  const trecho = `\n\nLocalização: ${enderecoShow}`;
  return base + encodeURIComponent(trecho);
}

/* ===== Geolocalização robusta ===== */
function getCurrentPosition(opts = {}) {
  return new Promise((resolve, reject) => {
    if (!("geolocation" in navigator))
      return reject(new Error("geolocation-unsupported"));
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 18000,
      maximumAge: 0,
      ...opts,
    });
  });
}

/* Remove camadas administrativas do display_name em string */
function limpaEnderecoStr(s) {
  if (!s || typeof s !== "string") return "";
  const BAN =
    /(regi[aã]o|geogr[aá]fica|metropol|imediata|intermedi[áa]ria|mesorregi|microrregi|sudeste|sul|norte|centro-?oeste|brasil)/i;

  // mantém CEP se existir
  const cepMatch = s.match(/\b\d{5}-?\d{3}\b/);
  const cep = cepMatch ? cepMatch[0] : "";

  const partesFiltradas = s
    .split(",")
    .map((p) => p.trim())
    .filter(Boolean)
    // remove tokens administrativos e “São Paulo” (estado) se vier solto
    .filter((p) => !BAN.test(p) && !/^s(ão|ao)\s*paulo$/i.test(p));

  const compacto = partesFiltradas.join(", ");
  return cep ? `${compacto}${compacto ? ", " : ""}${cep}` : compacto;
}

/* Reverse geocode: tenta sua API e cai para Nominatim /reverse */
async function reverseGeocode(lat, lng) {
  // 1) sua API local
  try {
    const r = await fetch(`/api/revgeo.php?lat=${lat}&lng=${lng}`);
    const j = await r.json(); // { address: {...} } ou { endereco: "..." }
    if (j?.address) return normalizeAddress(j.address);
    if (j?.endereco) {
      const compacto = limpaEnderecoStr(j.endereco);
      return {
        formatted: compacto,
        ruaNumero: compacto.split(",")[0] || compacto,
        cidadeUF: "",
        cep: (j.endereco.match(/\b\d{5}-?\d{3}\b/) || [])[0] || "",
      };
    }
  } catch {}
  // 2) Nominatim reverse (fallback no cliente)
  try {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&addressdetails=1&zoom=18&lat=${lat}&lon=${lng}`;
    const r2 = await fetch(url, { headers: { "Accept-Language": "pt-BR" } });
    const j2 = await r2.json();
    if (j2?.address) return normalizeAddress(j2.address);
  } catch {}
  return null; // sem endereço
}

/* Melhor fonte de localização (browser, depois IP+revgeo) */
async function getBestLocation() {
  try {
    const pos = await getCurrentPosition();
    const lat = pos.coords.latitude;
    const lng = pos.coords.longitude;
    const naddr = await reverseGeocode(lat, lng);
    return { lat, lng, naddr, fonte: "browser", accuracy: pos.coords.accuracy };
  } catch {}
  try {
    const r = await fetch(`/api/ipgeo.php`);
    const j = await r.json(); // { lat, lng }
    const lat = j.lat,
      lng = j.lng;
    const naddr = await reverseGeocode(lat, lng);
    return { lat, lng, naddr, fonte: "ip" };
  } catch {
    throw new Error("no-location");
  }
}

export default function Navigation() {
  const [open, setOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const [subOpen, setSubOpen] = React.useState(false);

  // ===== Modal de localização =====
  const [showLocModal, setShowLocModal] = React.useState(false);
  const [modalStep, setModalStep] = React.useState("ask"); // ask | loading | error

  // ✅ coloque aqui, dentro do componente
  const [locEtaClass, setLocEtaClass] = React.useState("");

  // refs
  const caretRef = React.useRef(null);
  const closeTimer = React.useRef(null);

  const isDesktop = () => !window.matchMedia("(max-width: 960px)").matches;

  const openWithCancel = () => {
    if (!isDesktop()) return;
    clearTimeout(closeTimer.current);
    setSubOpen(true);
  };
  const closeWithDelay = () => {
    if (!isDesktop()) return;
    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => setSubOpen(false), 170);
  };

  // categoria ativa sincronizada com a URL
  const [cat, setCat] = React.useState(
    () => new URLSearchParams(window.location.search).get("cat") || "todas"
  );

  // ====== LOCALIZAÇÃO ======
  const [locInput, setLocInput] = React.useState("");
  const [locBusy, setLocBusy] = React.useState(false);
  const [locHint, setLocHint] = React.useState("");
  const [localizacaoAtual, setLocalizacaoAtual] = React.useState(() => {
    const saved = sessionStorage.getItem("localizacaoAtual");
    return saved ? JSON.parse(saved) : null;
  });
  const [locFmt, setLocFmt] = React.useState(null);

  /* >>> Assim que o site abre: mostra a modal para pedir permissão <<< */
  React.useEffect(() => {
    if (localizacaoAtual) return;
    const { protocol, hostname } = window.location;
    const isSecure =
      Boolean(window.isSecureContext) ||
      /^https:/.test(protocol) ||
      /^(localhost|127\.0\.0\.1)$/.test(hostname);
    if (isSecure) setShowLocModal(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Mensagem padrão do botão "Solicitar"
  const WHATS_BASE =
    `https://wa.me/${WHATS_NUMBER_E164}?text=` +
    encodeURIComponent("Olá! Quero uma bateria com entrega e instalação.");

  const whatsLinkHero = buildWhatsMsgNoEta(WHATS_BASE, localizacaoAtual);

  React.useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const navigateSpa = (e, href) => {
    if (/^(https?:|mailto:|tel:|#)/.test(href)) return;
    e.preventDefault();
    const samePath = href === window.location.pathname;
    window.history.pushState({}, "", href);
    window.dispatchEvent(new PopStateEvent("popstate"));
    setOpen(false);
    setSubOpen(false);
    if (href === "/" || samePath)
      requestAnimationFrame(() =>
        window.scrollTo({ top: 0, left: 0, behavior: "smooth" })
      );
  };

  // >>> NOVO COMPORTAMENTO DO SEARCH: abre o WhatsApp com a pesquisa + categoria + localização
  function handleSearch(e) {
    e.preventDefault();

    const q = new FormData(e.currentTarget).get("q")?.toString().trim();

    // Linha principal: com ou sem termo de pesquisa
    const linhas = [];
    if (q) {
      linhas.push(
        `Olá! Vim pelo site e preciso de ajuda para escolher a bateria ideal marca: *${q}*.`
      );
    } else {
      linhas.push(
        "Olá! Vim pelo site e preciso de ajuda para escolher a bateria ideal marca: "
      );
    }

    // Localização (se tivermos)
    if (localizacaoAtual) {
      const endereco =
        localizacaoAtual.endereco && localizacaoAtual.endereco.length > 3
          ? `${localizacaoAtual.endereco}${
              localizacaoAtual.cep ? ` – CEP ${localizacaoAtual.cep}` : ""
            }`
          : fmtCoords(localizacaoAtual.lat, localizacaoAtual.lng);
      linhas.push(`Minha localização é: ${endereco}`);
    }

    const text = linhas.join("\n");
    const link =
      `https://wa.me/${WHATS_NUMBER_E164}?text=` + encodeURIComponent(text);

    window.open(link, "_blank");
  }

  function handleBateriasClick(e) {
    if (e.metaKey || e.ctrlKey) return;
    e.preventDefault();
    e.stopPropagation();
    setSubOpen((v) => !v);
  }

  // fecha submenu ao clicar fora quando menu aberto
  React.useEffect(() => {
    if (!open) return;
    const onDocClick = (ev) => {
      if (caretRef.current && !caretRef.current.contains(ev.target))
        setSubOpen(false);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [open]);

  React.useEffect(() => {
    if (!open) setSubOpen(false);
  }, [open]);

  React.useEffect(() => {
    const mq = window.matchMedia("(max-width: 960px)");
    const onChange = () => {
      if (!mq.matches) setSubOpen(false);
    };
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);

  function setCategory(next) {
    setCat(next);
    const url = new URL(window.location.href);
    url.searchParams.set("cat", next);
    window.history.pushState({}, "", url);
    window.dispatchEvent(new CustomEvent("catalog:category", { detail: next }));
  }

  React.useEffect(() => {
    const onPop = () => {
      const current =
        new URLSearchParams(window.location.search).get("cat") || "todas";
      setCat(current);
      window.dispatchEvent(
        new CustomEvent("catalog:category", { detail: current })
      );
    };
    window.addEventListener("popstate", onPop);
    window.dispatchEvent(new CustomEvent("catalog:category", { detail: cat }));
    return () => window.removeEventListener("popstate", onPop);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function aplicarLocal(base) {
    const { lat, lng } = base;
    const addr = base.naddr || null; // nunca pedimos número

    const km = distanceKm(ORIGEM, { lat, lng });
    const eta = etaByDistanceKM(km);
    const etaClass = km <= 10 ? "is-eta-soon" : "is-eta-later";

    const loc = {
      lat,
      lng,
      km,
      eta,
      fonte: base.fonte,
      endereco: addr?.formatted || "",
      cep: addr?.cep || "",
      ruaNumero: addr?.ruaNumero || "",
      cidadeUF: addr?.cidadeUF || "",
    };

    window.localizacaoAtual = loc;
    sessionStorage.setItem("localizacaoAtual", JSON.stringify(loc));
    setLocalizacaoAtual(loc);

    setLocHint(eta);
    setLocEtaClass(etaClass);

    const show =
      loc.endereco && loc.endereco.length > 3
        ? `${loc.endereco}${loc.cep ? ` – CEP ${loc.cep}` : ""}`
        : fmtCoords(lat, lng);
    setLocInput(show);

    setLocFmt(
      loc.endereco
        ? {
            ruaNumero: loc.ruaNumero || loc.endereco,
            bairro: "",
            cidadeUF: `${loc.cidadeUF}${loc.cep ? ` • CEP ${loc.cep}` : ""}`,
          }
        : null
    );

    window.dispatchEvent(new CustomEvent("location:update", { detail: loc }));
  }

  async function requestAndApplyLocation() {
    try {
      setModalStep("loading");
      setLocBusy(true);
      const best = await getBestLocation();
      aplicarLocal(best);
      setShowLocModal(false);
    } catch (err) {
      console.error(err);
      setModalStep("error");
    } finally {
      setLocBusy(false);
    }
  }

  async function handleUseMyLocation() {
    requestAndApplyLocation(); // pin usa o mesmo fluxo da modal
  }

  async function handleLocateByText(e) {
    e.preventDefault();
    const q = locInput.trim();
    if (!q) return;
    try {
      setLocBusy(true);
      const r = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&limit=1&addressdetails=1&countrycodes=br&q=${encodeURIComponent(
          q
        )}`,
        { headers: { "Accept-Language": "pt-BR" } }
      );
      const data = await r.json();
      if (!data?.length) {
        alert(
          "Endereço não encontrado. Tente Rua/Avenida, Nº, Bairro, Cidade."
        );
        return;
      }
      const lat = parseFloat(data[0].lat);
      const lng = parseFloat(data[0].lon);
      const naddr = normalizeAddress(data[0].address);

      aplicarLocal({ lat, lng, naddr, fonte: "texto" });
      setShowLocModal(false);
    } finally {
      setLocBusy(false);
    }
  }

  function handleCategoryClick(e, nextCat) {
    e.preventDefault();
    setCategory(nextCat);
    setOpen(false);
    setSubOpen(false);
    const sec =
      document.getElementById("baterias") ||
      document.querySelector(".sec.container");
    if (sec) sec.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  return (
    <>
      {/* ===== Modal de Permissão de Localização ===== */}
      {showLocModal && (
        <div
          className="loc-modal"
          role="dialog"
          aria-modal="true"
          aria-labelledby="loc-modal-title"
        >
          <div className="loc-modal__card">
            <img
              className="loc-modal__logo"
              src={logoBa}
              alt="Baterias Agora"
            />
            <h2 id="loc-modal-title" className="loc-modal__title">
              Permitir localização?
            </h2>

            {modalStep === "ask" && (
              <p className="loc-modal__desc">
                Usamos sua localização exata para estimar o tempo de entrega e
                preencher seu endereço automaticamente.
              </p>
            )}
            {modalStep === "loading" && (
              <p className="loc-modal__desc">Obtendo sua localização…</p>
            )}
            {modalStep === "error" && (
              <p className="loc-modal__desc loc-modal__desc--error">
                Não foi possível obter a localização. Você pode digitar seu
                endereço na barra abaixo.
              </p>
            )}

            <div className="loc-modal__actions">
              <button
                className="btn btn--primary"
                onClick={requestAndApplyLocation}
                disabled={modalStep === "loading"}
              >
                Permitir localização
              </button>
              <button
                className="btn btn--ghost"
                onClick={() => setShowLocModal(false)}
                disabled={modalStep === "loading"}
              >
                Digitar endereço
              </button>
            </div>
          </div>
        </div>
      )}

      {/* NAV FIXA */}
      <header
        className={`ba-nav ${scrolled ? "is-scrolled" : ""}`}
        aria-label="Principal"
      >
        <div className="container nav__bar">
          <a
            className="brand-title"
            href="/"
            onClick={(e) => navigateSpa(e, "/")}
            aria-label="Página inicial"
            title="Baterias Agora"
          >
            <img
              className="brand-title__truck"
              src={iconCaminhao}
              alt="Entrega rápida"
            />
            <span className="brand-title__word">Baterias</span>
            <img className="brand-title__bolt" src={boltIcon} alt="" />
            <span className="brand-title__word">Agora</span>
            <p className="subtitle-delivery">
              Entregamos e Instalamos em até 40 minutos
            </p>
          </a>

          <button
            className={`hamburger ${open ? "is-open" : ""}`}
            aria-expanded={open}
            aria-controls="menu"
            onClick={() => setOpen((v) => !v)}
          >
            <span />
            <span />
            <span />
            <span className="sr-only">Abrir menu</span>
          </button>

          {/* ORDEM: Home, Contato, Baterias */}
          <ul id="menu" className={`menu ${open ? "is-open" : ""}`}>
            <li>
              <a className="link" href="/" onClick={(e) => navigateSpa(e, "/")}>
                Home
              </a>
            </li>
            <li>
              <a
                className="link"
                href="/#contato"
                onClick={(e) => {
                  e.preventDefault();
                  setOpen(false);
                  setSubOpen(false);
                  setTimeout(() => {
                    const el = document.getElementById("contato");
                    if (el)
                      el.scrollIntoView({ behavior: "smooth", block: "start" });
                  }, 0);
                }}
              >
                Contato
              </a>
            </li>

            {/* BATERIAS — último item */}
            <li
              ref={caretRef}
              className={`has-caret ${subOpen ? "is-open" : ""}`}
              onMouseEnter={openWithCancel}
              onMouseLeave={closeWithDelay}
            >
              <a
                className="link link--parent"
                href="/baterias"
                aria-haspopup="true"
                aria-expanded={subOpen}
                onClick={handleBateriasClick}
                title="Ver categorias de baterias"
              >
                Baterias
                <svg width="12" height="12" viewBox="0 0 24 24" aria-hidden>
                  <path fill="currentColor" d="m7 10 5 5 5-5z" />
                </svg>
              </a>
              <ul
                className="dropdown"
                role="menu"
                aria-label="Categorias"
                onMouseEnter={openWithCancel}
                onMouseLeave={closeWithDelay}
              >
                <li role="none">
                  <a
                    role="menuitem"
                    href="/#baterias"
                    onClick={(e) => handleCategoryClick(e, "todas")}
                  >
                    Todas
                  </a>
                </li>
                <li role="none">
                  <a
                    role="menuitem"
                    href="/#baterias"
                    onClick={(e) => handleCategoryClick(e, "automotivas")}
                  >
                    Automotivas
                  </a>
                </li>
                <li role="none">
                  <a
                    role="menuitem"
                    href="/#baterias"
                    onClick={(e) => handleCategoryClick(e, "pesada")}
                  >
                    Linha Pesada
                  </a>
                </li>
                <li role="none">
                  <a
                    role="menuitem"
                    href="/#baterias"
                    onClick={(e) => handleCategoryClick(e, "motos")}
                  >
                    Motos
                  </a>
                </li>
              </ul>
            </li>

            <li className="menu__divider" aria-hidden="true" />

            <li className="menu__cta">
              <a
                href={whatsLinkHero}
                className="btn btn--outline btn--solicitar"
                target="_blank"
                rel="noreferrer"
                aria-label="Peça agora pelo WhatsApp"
              >
                <img
                  src={iconWhats}
                  alt="WhatsApp"
                  className="btn__icon-whats"
                  aria-hidden="true"
                />
                <span>16 98217-2448</span>
              </a>
            </li>
          </ul>
        </div>
      </header>

      {/* HERO */}
      <section
        className="nav-hero"
        role="banner"
        aria-label="Entrega e instalação de baterias com rapidez"
        style={{
          "--hero-image": `url(${heroImg})`,
          "--hero-gradient": `linear-gradient(0deg, rgba(8,22,40,.68) 0%, rgba(8,22,40,.38) 100%)`,
        }}
      >
        {/* ===== PÍLULA DE LOCALIZAÇÃO ===== */}
        <form
          className={`hero__loc ${locFmt ? "has-formatted" : ""}`}
          onSubmit={handleLocateByText}
        >
          <button
            type="button"
            className="loc__pin"
            onClick={handleUseMyLocation}
            aria-label="Usar minha localização atual"
            disabled={locBusy}
            title="Usar minha localização atual"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
              <path
                fill="currentColor"
                d="M12 2a7 7 0 0 0-7 7c0 5.25 7 13 7 13s7-7.75 7-13a7 7 0 0 0-7-7Zm0 9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5Z"
              />
            </svg>
          </button>

          {/* preview multi-linha (apenas mobile via CSS) */}
          <div className="loc__formatted" aria-label="Endereço detectado">
            {locFmt ? (
              <>
                <span className="loc__line">{locFmt.ruaNumero}</span>
                {locFmt.bairro && (
                  <span className="loc__line">{locFmt.bairro}</span>
                )}
                <span className="loc__line">{locFmt.cidadeUF}</span>
              </>
            ) : null}
          </div>

          {/* input permanece para desktop/edição */}
          <input
            className="loc__input"
            value={locInput}
            onChange={(e) => setLocInput(e.target.value)}
            placeholder={
              locBusy
                ? "detectando sua localização..."
                : "Informe sua localização"
            }
            autoComplete="off"
          />

          <span className="loc__dots" aria-hidden="true">
            <i />
            <i />
            <i />
          </span>

          <button
            className="loc__search"
            aria-label="Buscar localização"
            disabled={locBusy}
            title="Buscar localização"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
              <path
                fill="currentColor"
                d="m21 20.3-4.7-4.7a7.5 7.5 0 1 0-1.4 1.4L20.3 21zM5 10.5a5.5 5.5 0 1 1 5.5 5.5A5.5 5.5 0 0 1 5 10.5"
              />
            </svg>
          </button>

          {locHint && (
            <span className={`loc__eta ${locEtaClass}`} aria-live="polite">
              {locHint}
            </span>
          )}
        </form>

        <div className="hero__fx" aria-hidden="true" />
        <div className="container hero__grid">
          <div className="hero__content">
            <p className="hero__badge">⚡ Entrega e Instalação Express</p>
            <h1 className="hero__title hero__title--grid">
              <span>
                Entrega <span className="accent">Express</span>
              </span>
              <br />
              <span>
                em até <span aria-hidden>🕒</span>{" "}
                <span className="accent">40 minutos</span>
              </span>
            </h1>
            <p className="hero__desc">
              Baterias automotivas com as melhores marcas do mercado.
              <br />
              <br />
              <span className="entrega-batatais">
                Entrega GRÁTIS em Batatais e instalação profissional.
              </span>
            </p>

            <div className="hero__cta-strip">
              <a
                href={whatsLinkHero}
                className="btn btn--outline btn--solicitar"
                target="_blank"
                rel="noreferrer"
                aria-label="Peça agora pelo WhatsApp"
              >
                <img
                  src={iconWhats}
                  alt="WhatsApp"
                  className="btn__icon-whats"
                  aria-hidden="true"
                />
                <span>Peça agora</span>
              </a>

              <span className="cta-line" aria-hidden="true" />

              <div className="mini-carousel" aria-label="Marcas de baterias">
                <img src={imgHeliar} alt="Bateria Heliar" />
                <img src={imgMoura} alt="Bateria automotiva" />
                <img src={imgLumix} alt="Bateria Lumix" />
                <img src={imgCaminhaoJupiter} alt="Bateria Jupiter" />
                <img src={imgMouraCaminhao} alt="Bateria Moura Caminhao" />
                <img src={imgZettaCarro} alt="Bateria Zetta Carro" />
                <img src={imgMouraMoto} alt="Bateria Moura Moto" />
                <img src={imgMarteMoto} alt="Bateria Marte Moto" />
                <img src={imgBateriaMoura} alt="Bateria Moura Carro" />
              </div>
            </div>

            {/* BUSCA PRODUTOS -> abre WhatsApp com a pesquisa */}
            <form
              className="hero__search"
              onSubmit={handleSearch}
              role="search"
              aria-label="Buscar produtos"
            >
              <input
                name="q"
                type="search"
                placeholder="Buscar por marca, modelo ou tipo de bateria..."
                autoComplete="off"
              />
              <button className="search-btn" aria-label="Buscar">
                <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden>
                  <path
                    fill="currentColor"
                    d="m21 20.3-4.7-4.7a7.5 7.5 0 1 0-1.4 1.4L20.3 21zM5 10.5a5.5 5.5 0 1 1 5.5 5.5A5.5 5.5 0 0 1 5 10.5"
                  />
                </svg>
              </button>
            </form>

            {/* FILTROS */}
            <div className="hero__filters">
              <span className="hero__filters-label">
                <svg width="16" height="16" viewBox="0 0 24 24" aria-hidden>
                  <path fill="currentColor" d="M3 4h18v2l-7 8v5l-4 2v-7L3 6z" />
                </svg>
                Categoria:
              </span>

              <button
                type="button"
                className={`chip-btn ${cat === "todas" ? "is-active" : ""}`}
                onClick={() => {
                  setCategory("todas");
                  const sec =
                    document.getElementById("baterias") ||
                    document.querySelector(".sec.container");
                  if (sec)
                    sec.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Todas
              </button>

              <button
                type="button"
                className={`chip-btn ${
                  cat === "automotivas" ? "is-active" : ""
                }`}
                onClick={() => {
                  setCategory("automotivas");
                  const sec =
                    document.getElementById("baterias") ||
                    document.querySelector(".sec.container");
                  if (sec)
                    sec.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Automotivas
              </button>

              <button
                type="button"
                className={`chip-btn ${cat === "motos" ? "is-active" : ""}`}
                onClick={() => {
                  setCategory("motos");
                  const sec =
                    document.getElementById("baterias") ||
                    document.querySelector(".sec.container");
                  if (sec)
                    sec.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Motos
              </button>

              <button
                type="button"
                className={`chip-btn ${cat === "pesada" ? "is-active" : ""}`}
                onClick={() => {
                  setCategory("pesada");
                  const sec =
                    document.getElementById("baterias") ||
                    document.querySelector(".sec.container");
                  if (sec)
                    sec.scrollIntoView({ behavior: "smooth", block: "start" });
                }}
              >
                Linha Pesada
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
